import { mintCircuitId } from "../addedCircuits";
import { FEEDER_KEY } from "./constants";

// Keyed on the FED board, so his answers on it survive a change of the board upstream.
export const feederCircuitId = (toLabel: string): string =>
  mintCircuitId({ boardName: toLabel, key: FEEDER_KEY });

export const feederElementId = (toLabel: string): string => `board:${toLabel}`;

export const feederDestinationId = (toLabel: string): string => `feeder:${toLabel}`;
